import { ItemShowOptions } from '../type/item-query'
import { FC } from 'react'
import { FormEntryField } from '../../../core/type'
import { Select } from 'antd'
import { translate } from '../../../core'

export const showItemOptionsMapper: Record<ItemShowOptions, { label: string, value: boolean | undefined }> = {
  [ItemShowOptions.All] : {
    label: translate('all'),
    value: undefined,
  },
  [ItemShowOptions.ArchivedOnly]: {
    label: translate('archives_only'),
    value: true,
  },
  [ItemShowOptions.NoneArchived]: {
    label: translate('none_archives'),
    value: false,
  },
}

export type ShowItemOptionsSelectProps = FormEntryField<ItemShowOptions> & {
  disabled?: boolean
}
export const ShowItemOptionsSelect: FC<ShowItemOptionsSelectProps> = ({value, onChange, disabled}) => (
  <Select
    value={value}
    onChange={onChange}
    disabled={disabled}
    className='w-100'
    options={Object.entries(showItemOptionsMapper).map(([key, value]) => ({
      key,
      value: key,
      label: value.label,
    }))}
  />
)